module.exports = __webpack_public_path__ + "static/media/complete_bar.cb04e8dd.svg";